export enum LoanStatusType {
    Sanctioned = 'sanctioned',
    Accepted = 'accepted',
    BankDetailsFilled = 'bank_details_filled',
    QueuedToBeFulfilled = 'queued_to_be_fulfilled',
    Fulfilled = 'loan_fulfilled',
    DocumentCollected = 'document_collected',
    DocumentVerified = 'document_verified',
    ReadyForDisbursal = 'ready_for_disbursal',
    DisbursalInitiated = 'loan_disbursed_initiated',
    Disbursed = 'loan_disbursed',
    DocumentHardcopyReceived = 'document_hardcopy_recieved',
    ClosedPrepayment = 'closed_prepayment',
    LoanMatured = 'loan_matured',
    SubStandardAsset = 'sub_standard_asset',
    LossAsset = 'loss_asset',
    Rejected = 'rejected',
    Closed = 'closed',
    ClosedSettlement = 'closed_settlement'
}

export enum TransferStatus {
    TRANSFER_IN_TRANSIT = 'transfer_in_transit',
    TRANSFER_COMPLETE = 'transfer_complete'
}

export enum DisplayableLoanStatus {
    InProgress = 'In Progress', PrepaidAndClosed = 'Prepaid & Closed', MaturedAndClosed = 'Matured & Closed',
    Closed = 'Closed', SettledAndClosed = 'Settled & Closed', Rejected = 'Rejected', Active = 'Active', RestructuredAndActive = 'Restructured & Active'
}

export class LoanStatus {
    private static orderedStatus = [LoanStatusType.Sanctioned, LoanStatusType.Accepted, LoanStatusType.QueuedToBeFulfilled,
        LoanStatusType.Fulfilled, LoanStatusType.DocumentCollected, LoanStatusType.DocumentVerified, LoanStatusType.ReadyForDisbursal, LoanStatusType.DisbursalInitiated, LoanStatusType.Disbursed, LoanStatusType.DocumentHardcopyReceived];
    private static activeDisbursalLoanStatuses = [LoanStatusType.DocumentHardcopyReceived, LoanStatusType.Disbursed];
    private static afterDisbursalStatus = [LoanStatusType.Disbursed, LoanStatusType.DocumentHardcopyReceived, LoanStatusType.ClosedPrepayment, LoanStatusType.LoanMatured, LoanStatusType.SubStandardAsset, LoanStatusType.LossAsset];
    private static afterAcceptanceAndBeforeDisbursalStatus = [LoanStatusType.Accepted, LoanStatusType.BankDetailsFilled, LoanStatusType.QueuedToBeFulfilled,
        LoanStatusType.Fulfilled, LoanStatusType.DocumentCollected, LoanStatusType.DocumentVerified, LoanStatusType.ReadyForDisbursal, LoanStatusType.DisbursalInitiated];
    private static completelyRepaidStatus = [LoanStatusType.ClosedPrepayment, LoanStatusType.LoanMatured, LoanStatusType.ClosedSettlement];
    private static rejectedStatus = [LoanStatusType.Rejected];
    private static closedBeforeDisbursal = [LoanStatusType.Closed];

    private static lenderNegotiationStatus = [
        LoanStatusType.Accepted, LoanStatusType.BankDetailsFilled, LoanStatusType.QueuedToBeFulfilled,
        LoanStatusType.Fulfilled, LoanStatusType.DocumentCollected, LoanStatusType.DocumentVerified,
        LoanStatusType.ReadyForDisbursal
    ];

    static hasBeenAccepted(status: LoanStatusType): boolean {
        return LoanStatus.order(status) >= LoanStatus.order(LoanStatusType.Accepted) || LoanStatus.hasBeenDisbursed(status);
    }

    static hasBeenFulfilled(status: LoanStatusType): boolean {
        return LoanStatus.order(status) >= LoanStatus.order(LoanStatusType.Fulfilled) || LoanStatus.hasBeenDisbursed(status);
    }

    static isActiveAndDisbursed(status: LoanStatusType): boolean {
        return this.activeDisbursalLoanStatuses.some(aStatus => aStatus === status);
    }

    static hasBeenDisbursed(status: LoanStatusType): boolean {
        return this.afterDisbursalStatus.some(aStatus => aStatus === status);
    }

    static hasToShowLoanSuggestedTerm(status: LoanStatusType): boolean {
        return this.lenderNegotiationStatus.includes(status);
    }

    static isAcceptedButYetToBeDisbursed(status: LoanStatusType): boolean {
        return this.afterAcceptanceAndBeforeDisbursalStatus.some(aStatus => aStatus === status);
    }

    static  hasBeenCompletelyRepaid(status: LoanStatusType): boolean {
        return this.completelyRepaidStatus.some(aStatus => aStatus === status);
    }

    static hasBeenClosedBeforeDisbursal(status: LoanStatusType): boolean {
        return this.closedBeforeDisbursal.some(aStatus => aStatus === status);
    }

    static isRejected(status: LoanStatusType): boolean {
        return this.rejectedStatus.some(aStatus => aStatus === status);
    }

    static areDocumentsSigned(status: LoanStatusType): boolean {
        return LoanStatus.order(status) >= LoanStatus.order(LoanStatusType.DocumentCollected);
    }

    private static order(status: LoanStatusType) {
        return this.orderedStatus.indexOf(status as any);
    }
}